import nvBuildsModule from '../../core/nv.builds.module';
import nvSharedErrorHandlingModule from '../../shared/error-handling/nv.shared.error-handling.module';
import nvSharedServicesModule from '../services/nv.shared.services.module';
import nvSharedServicesUtilsModule from '../services/utilities/nv.shared.services.utils.module';
import nvSharedStaticModelsModule from '../static-models/nv.shared.static-models.module';
import { DocLog } from './doc-log/doc-log';

export default angular
  .module('nv.shared.models', [
    'ngResource',
    nvBuildsModule,
    nvSharedServicesUtilsModule,
    nvSharedStaticModelsModule,
    'ui.router',
    nvSharedErrorHandlingModule,
    nvSharedServicesModule,
  ])
  .factory('DocLog', DocLog).name;
